import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Role } from '@/modules/roles/roles.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createRole = () => ({
  body: generateJoiValidation(Role.schema),
});

export const updateRole = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Role.schema, true),
});

export const getRole = {
  query: Joi.object().keys({
    name: Joi.string(),
    role: Joi.string(),
    sortBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getRoleById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteRoleById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
